import { render, staticRenderFns } from "./OStep6.vue?vue&type=template&id=136811ec&scoped=true"
import script from "./OStep6.vue?vue&type=script&lang=js"
export * from "./OStep6.vue?vue&type=script&lang=js"
import style0 from "./OStep6.vue?vue&type=style&index=0&id=136811ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136811ec",
  null
  
)

export default component.exports